<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between start" style="align-items: flex-start;">
  <span class="smaller-font" style="font-size: 12px;">{{data.title}}</span>
  <button mat-icon-button class="close-button" type="button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="dialog-content">
  <mat-card class="p-0">
    <form [formGroup]="parcelaForm" (ngSubmit)="submit()" (keydown.enter)="$event.preventDefault()">
      <mat-card-content class="popup-form-content">
        <div fxLayout="row wrap" fxLayoutGap="16px" class="parcela-grid">
          <div fxFlex="25" fxFlex.xs="100" class="pl-1">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Emissão</mat-label>
              <input matInput [matDatepicker]="emissao" [formControl]="parcelaForm.controls['emissao']" readonly>
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="emissao" disabled></mat-datepicker-toggle>
              <mat-datepicker #emissao startView="month" disabled></mat-datepicker>
              <mat-error *ngIf="parcelaForm.controls['emissao'].hasError('required') && parcelaForm.controls['emissao'].touched">
                Emissão é obrigatória
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="25" fxFlex.xs="100" class="pl-1">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Vencimento</mat-label>
              <input
                matInput
                [matDatepicker]="vcto"
                [formControl]="parcelaForm.controls['vcto']"
                [readonly]="!layoutConf?.isMobile"
                (click)="layoutConf?.isMobile && vcto.open()">
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="vcto" [disabled]="!layoutConf?.isMobile"></mat-datepicker-toggle>
              <mat-datepicker #vcto startView="month" [disabled]="!layoutConf?.isMobile"></mat-datepicker>
              <mat-error *ngIf="parcelaForm.controls['vcto'].hasError('required') && parcelaForm.controls['vcto'].touched">
                Vencimento é obrigatório
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="25" fxFlex.xs="100" class="pl-1">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Data de Referência</mat-label>
              <input matInput [matDatepicker]="dataRef" [formControl]="parcelaForm.controls['dataref']">
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="dataRef"></mat-datepicker-toggle>
              <mat-datepicker #dataRef startView="month"></mat-datepicker>
            </mat-form-field>
          </div>
          <div fxFlex="25" fxFlex.xs="100" class="pl-1">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Prorrogação</mat-label>
              <input matInput [matDatepicker]="prorrogacao" [formControl]="parcelaForm.controls['prorrogacao']" (dateChange)="onProrrogacaoChange($event)">
              <mat-hint>DD/MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="prorrogacao"></mat-datepicker-toggle>
              <mat-datepicker #prorrogacao startView="month"></mat-datepicker>
            </mat-form-field>
          </div>
          <div fxFlex="95" fxFlex.xs="100" class="pl-1">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Prorrogação - Observações:</mat-label>
              <textarea matInput placeholder="Observações" name="prorrogacaoObs"
                [formControl]="parcelaForm.controls['prorrogacaoObs']">
              </textarea>
            </mat-form-field>
          </div>
          <div fxFlex="35" fxFlex.xs="100" class="pl-1">
            <mat-form-field class="full-width">
              <mat-label>Portador</mat-label>
              <mat-select [formControl]="parcelaForm.controls['portadorId']"
                (selectionChange)="onSelectionChangePortador($event)">
                <mat-option>
                  <ngx-mat-select-search [formControl]="parcelaForm.controls['searchPortador']"
                    placeholderLabel="Pesquisar Portador." noEntriesFoundLabel="Portador não encontrado"
                    [searching]="searching">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let portador of portadores" [value]="portador">
                  <span>{{ portador?.codigo?.toString().padStart(5, '0') +"-" + portador?.descricao }}</span>
                </mat-option>
              </mat-select>
              <mat-error *ngIf="parcelaForm.controls['portadorId'].hasError('required') && parcelaForm.controls['portadorId'].touched">
                Portador é obrigatório
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="35" fxFlex.xs="100" class="pl-1">
            <mat-form-field class="full-width">
              <mat-label>Tipo de Cobrança</mat-label>
              <mat-select [formControl]="parcelaForm.controls['tipoCobranca']"
                (selectionChange)="onSelectionChangeTipoCobranca($event)">
                <mat-option>
                  <ngx-mat-select-search [formControl]="parcelaForm.controls['searchTipoCobranca']"
                    placeholderLabel="Pesquisar Tipo de Cobrança"
                    noEntriesFoundLabel="Tipo de Cobrança não encontrado" [searching]="searching">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let tipoCobranca of tipoCobrancas" [value]="tipoCobranca">
                  <span>{{ tipoCobranca?.codigo?.toString().padStart(5, '0') +"-" + tipoCobranca?.descricao }}</span>
                </mat-option>
              </mat-select>
              <mat-error *ngIf="parcelaForm.controls['tipoCobranca'].hasError('required') && parcelaForm.controls['tipoCobranca'].touched">
                Tipo de Cobrança é obrigatório
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="35" fxFlex.xs="100" class="pl-1">
            <mat-form-field class="full-width">
              <mat-label>(=) Valor Nominal:</mat-label>
              <input matInput id="valorTotal" type="text" name="valorTotal" step="any"
                (focus)="$event.target.select()" appOnReturn [formControl]="parcelaForm.controls['valorTotal']"
                placeholder="Valor Nominal" currencyMask
                [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }" readonly>
            </mat-form-field>
          </div>
          <div fxFlex="35" fxFlex.xs="100" class="pl-1">
            <mat-form-field class="full-width">
              <mat-label>(+) Multa/Acréscimo:</mat-label>
              <input matInput id="valorAcrescimo" type="text" name="valorAcrescimo" step="any"
                (focus)="$event.target.select()" appOnReturn [formControl]="parcelaForm.controls['valorAcrescimo']"
                placeholder="Multa/Acréscimo" currencyMask
                [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }" readonly style="font-weight: bold; color: red;">
            </mat-form-field>
          </div>
          <div fxFlex="35" fxFlex.xs="100" class="pl-1">
            <mat-form-field class="full-width">
              <mat-label>(+) Juros Mora:</mat-label>
              <input matInput id="valorJurosmora" type="text" name="valorJurosmora" step="any"
                (focus)="$event.target.select()" appOnReturn [formControl]="parcelaForm.controls['valorJurosmora']"
                placeholder="Juros Mora" currencyMask
                [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }" readonly style="font-weight: bold; color: red;">
            </mat-form-field>
          </div>
          <div fxFlex="35" fxFlex.xs="100" class="pl-1">
            <mat-form-field class="full-width">
              <mat-label>(-) Valor Desconto:</mat-label>
              <input matInput id="valorDesconto" type="text" name="valorDesconto" step="any"
                (focus)="$event.target.select()" appOnReturn [formControl]="parcelaForm.controls['valorDesconto']"
                placeholder="Desconto" currencyMask
                [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }" readonly style="font-weight: bold; color: blue;">
            </mat-form-field>
          </div>
          <div fxFlex="35" fxFlex.xs="100" class="pl-1">
            <mat-form-field class="full-width">
              <mat-label>(=) Valor em Aberto (Saldo):</mat-label>
              <input matInput id="valorSaldo" type="text" name="valorSaldo" step="any"
                (focus)="$event.target.select()" appOnReturn [formControl]="parcelaForm.controls['valorSaldo']"
                placeholder="Valor em Aberto (Saldo)" currencyMask
                [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }"
                readonly style="font-weight: bold;">
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <div fxLayout="row" fxLayoutAlign="center center" class="pl-1 popup-actions-bar">
          <button mat-raised-button color="primary" class="popup-primary-btn" [disabled]="parcelaForm.invalid || parcelaForm.hasError('saldoDiferente')">
            <mat-icon>save</mat-icon>
            {{"SAVE" | translate}}
          </button>
          <button mat-raised-button color="primary" class="popup-primary-btn" [disabled]="!parcelaForm.hasError('saldoDiferente')" type="button" (click)="consultaBaixas(parcelaForm.value); $event.preventDefault();">
            <mat-icon>price_check</mat-icon>
            Baixas
          </button>
          <button mat-raised-button color="primary" class="popup-primary-btn popup-classes-btn" type="button" (click)="editClasses(parcelaForm.value); $event.preventDefault();">
            <mat-icon>list_alt</mat-icon>
            Classes/Centro de Custos
          </button>
          <span fxFlex class="popup-actions-spacer"></span>
          <button mat-button color="warn" type="button" (click)="close();">
            <mat-icon>close</mat-icon>
            Fechar
          </button>
        </div>
      </mat-card-actions>
    </form>
  </mat-card>
</div>